<template>
  <div class="QuestionAnswer">
    <div class="header-box">
      <div v-if="pageData.length > 0" id="scrollContainer" class="menu-box">
        <div
          v-for="(v, i) in pageData"
          :key="i"
          :class="{ on: v.webId == indexObj.webId }"
          @click="setIndex(v)"
        >
          {{ v.name }}
        </div>
      </div>
      <van-icon
        v-if="pageData.length > 5"
        name="ascending"
        size="28"
        @click="show = true"
      />
    </div>

    <template v-for="(v, i) in pageData">
      <template v-if="v.webId == indexObj.webId">
        <div :key="i" class="question-box">
          <p v-if="v.question && v.question.length > 0" class="title">
            【题干】
          </p>
          <div class="content" v-html="v.question"></div>
          <p v-if="v.answer && v.answer.length > 0" class="title">【答案】</p>
          <div class="content" v-html="v.answer"></div>
          <p v-if="v.analysis && v.analysis.length > 0" class="title">
            【解析】
          </p>
          <div class="content" v-html="v.analysis"></div>
          <p v-if="v.analyse && v.analyse.length > 0" class="title">【分析】</p>
          <div class="content" v-html="v.analyse"></div>
          <p v-if="v.ability && v.ability.length > 0" class="title">【点评】</p>
          <div class="content" v-html="v.ability"></div>
          <p v-if="v.resPointList && v.resPointList.length > 0" class="title">
            【知识点详解】
          </p>
          <div
            v-for="(item, index) in v.resPointList"
            :key="index + 'resPointList'"
          >
            <div>{{ chinese[index] }}丶{{ item.name }}</div>
            <div v-html="item.description"></div>
          </div>
          <van-button
            v-if="!v.answer && !v.analysis"
            type="primary"
            block
            :loading="aiLoading"
            @click="generateAnalysis"
          >
            AI生成答案解析
          </van-button>
        </div>
      </template>
    </template>
    <div v-if="msg.length > 0" class="question-box">
      <p class="err">{{ msg }}</p>
    </div>
    <van-action-sheet v-model="show" title="全部题目">
      <div class="content-box">
        <template v-for="(item, index) in pageData">
          <van-tag
            v-if="indexObj.webId == item.webId"
            :key="index"
            type="primary"
            size="large"
          >
            {{ item.name }}
          </van-tag>
          <van-tag
            v-else
            :key="index + 'set'"
            size="large"
            @click="setIndex(item, index)"
          >
            {{ item.name }}
          </van-tag>
        </template>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { Toast } from "vant";
import { examquestionanswerV2, generateAiAnswer } from "@/api/interface";
export default {
  name: "QuestionAnswer",
  data() {
    return {
      show: false,
      pageData: [],
      msg: "",
      menuList: [],
      chinese: ["一", "二", "三", "四", "五", "六"],
      indexObj: {},
      aiLoading: false,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    window.MathJax.typesetPromise();
  },
  updated() {
    window.MathJax.startup.defaultReady();
  },
  methods: {
    menuClick(index) {
      this.menuList.forEach((v) => {
        v.on = false;
      });
      this.menuList[index].on = true;
    },
    getData() {
      this.msg = "";
      examquestionanswerV2(this.$route.query).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          this.pageData = res.data;
          this.setDataList();
        } else {
          this.msg = res.data;
        }
      });
    },
    generateAnalysis() {
      const questionId = this.indexObj.id || this.indexObj.questionId;
      if (!questionId) {
        Toast("缺少试题信息");
        return;
      }
      if (this.aiLoading) {
        return;
      }
      this.aiLoading = true;
      Toast.loading({
        duration: 0,
        message: "AI生成中，请稍候...",
        forbidClick: true,
        loadingType: "spinner",
      });
      generateAiAnswer({
        questionId,
        type: 0,
      })
        .then((res) => {
          Toast.clear();
          this.aiLoading = false;
          if (res.code == 0) {
            this.applyAiAnswer(res.data);
            this.$nextTick(() => {
              this.initImg();
              if (window.MathJax && window.MathJax.typesetPromise) {
                window.MathJax.typesetPromise();
              }
            });
          } else {
            Toast.fail(res.msg || "生成失败");
          }
        })
        .catch(() => {
          Toast.clear();
          this.aiLoading = false;
        });
    },
    applyAiAnswer(data) {
      const idx = this.pageData.findIndex(
        (item) => item.webId == this.indexObj.webId
      );
      if (idx < 0 || !data) {
        return;
      }
      const item = this.pageData[idx];
      if (data.answer) {
        this.$set(item, "answer", data.answer);
      }
      if (data.analysis) {
        this.$set(item, "analysis", data.analysis);
      }
      this.indexObj = item;
      this.$set(this.pageData, idx, item);
    },
    setIndex(item, index) {
      this.indexObj = item;
      this.show = false;
      if (index > 0 || index === 0) {
        const container = document.getElementById("scrollContainer");
        const thirdChild = container.children[index]; // 第三个元素索引是2
        container.scrollTo({
          left: thirdChild.offsetLeft,
          behavior: "smooth",
        });
      }
      this.$nextTick(() => {
        this.initImg();
      });
    },
    initImg() {
      this.$nextTick(() => {
        var jzjxImg = document.getElementsByClassName("jzjxImg");

        const viewportWidth = window.innerWidth - 24;
        let maxWidth = viewportWidth,
          ratio = 1;
        let jzjxImgArr = [...Array.from(jzjxImg)];
        if (jzjxImgArr.length) {
          if (jzjxImgArr[0].style.maxWidth) {
            maxWidth = this.removePxToNumber(jzjxImgArr[0].style.maxWidth);
          }
          let width = this.removePxToNumber(jzjxImgArr[0].style.width);
          if (maxWidth < width) {
            maxWidth = width;
          }
          ratio = viewportWidth / maxWidth;
        }
        jzjxImgArr.forEach((item) => {
          if (item.name == "edit") return;

          item.name = "edit";
          const width = this.removePxToNumber(item.style.width);
          maxWidth = this.removePxToNumber(item.style.maxWidth);
          if (maxWidth < width) {
            maxWidth = width;
          }
          ratio = viewportWidth / maxWidth;
          item.style.width = width * ratio + "px";
          item.style.display = "block";
        });
      });
    },
    removePxToNumber(val) {
      let data = val.replace("px", "");
      return Number(data);
    },
    setDataList() {
      // let originId = "";
      let index = 0;
      this.pageData = this.pageData.map((item, key) => {
        item.webId = key + 1;
        if (!item.originId) {
          // originId = item.webId;
          index = 0;
          item.name = item.examPaperNum ? item.examPaperNum : "原题";
        } else {
          // if (item.originId == originId) {
          item.name = this.bigName(item.examPaperNum, index);
          index++;
          // }
        }
        return item;
      });
      this.indexObj = this.pageData[0];
      this.$nextTick(() => {
        this.initImg();
      });
      // this.pageData.forEach((item, index) => {
      //   let data = {
      //     id: item.webId,
      //     on: false,
      //   };
      //   if (this.pageData[0].isOrigin == 1) {
      //     if (index > 0) {
      //       data.name = this.bigName(item.examPaperNum, index - 1);
      //     } else {
      //       data.name = item.examPaperNum ? item.examPaperNum : "原题";
      //     }
      //   } else {
      //     data.name = this.bigName(item.examPaperNum, index);
      //   }
      //   this.menuList.push(data);
      //   // console.log(index);
      // });
      // this.menuList[0].on = true;
      // console.log(this.menuList);
    },
    bigName(left, index) {
      let arr = [];
      for (let i = 0; i < 100; i++) {
        if (index < 9) {
          arr.push("0" + (i + 1));
        } else {
          arr.push(i + 1);
        }
      }
      // console.log(arr);
      // console.log(left);
      // console.log(index);
      let str = (left ? left : "变式") + "_" + arr[index];
      // console.log(str);
      return str;
    },
  },
};
</script>
<style>
.pt1,
.pt2 {
  padding: 0;
}
</style>
<style scoped lang="scss">
.QuestionAnswer {
  .content-box {
    padding: 18px;
    min-height: calc(100vh - 50px);
    .van-tag {
      margin-right: 12px;
      margin-bottom: 12px;
      min-width: 55px;
      justify-content: center;
    }
    // display: flex;
    // flex-wrap: wrap;
    // align-items: center;
  }
  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    width: 100vw;
    left: 0;
    top: 0;
    background: white;
    z-index: 1;
    .van-icon {
      margin-right: 6px;
      margin-top: 6px;
    }
  }
  .menu-box {
    // padding: 0 8px;
    display: flex;
    align-items: center;
    width: calc(100vw - 40px);
    overflow-x: scroll;
    div {
      padding: 6px 12px;
      margin: 0 4px;
      white-space: nowrap;
    }
    .on {
      border-bottom: 1px solid #7b9cc7;
      color: #7b9cc7;
    }
  }
  .question-box {
    padding: 12px;
    margin-top: 30px;
    .van-button {
      margin-top: 16px;
    }
  }
  .err {
    color: rgb(240, 87, 87);
  }
  .title {
    color: #7b9cc7;
    margin-bottom: 8px;
  }
  .content {
    margin-bottom: 8px;
  }
}
</style>
